export default class APIConfig {
  static CREATE_BLOG = "/create-blog/blog";
  static GET_BLOG_BY_ID = "/create-blog/get-blog-by-id";
  static UPDATE_STATUS = "/create-blog/update-status";

  static GET_RETENTION = "/web-traffic/get-retention";
}
